export default "__VITE_ASSET__DXROagFI__"